import Layout from "@/components/Layout";
import PageHead from "@/components/PageHead";
import AnimatedSection from "@/components/AnimatedSection";

const industryGroups = [
  {
    category: "Core Competition Markets",
    industries: [
      { name: "Technology & Digital Platforms", desc: "Antitrust issues in digital markets, platform competition, and technology mergers." },
      { name: "Life Sciences & Pharmaceuticals", desc: "Competition matters involving pharmaceutical mergers, patent settlements, and market access." },
      { name: "Healthcare Markets", desc: "Merger review, provider consolidation, and payer competition issues." },
      { name: "Private Equity & Investment Firms", desc: "Antitrust considerations in roll-up strategies, portfolio company acquisitions, and fund investments." },
    ],
  },
  {
    category: "Regulated & Infrastructure Industries",
    industries: [
      { name: "Aerospace & Defense", desc: "Merger review and competition issues in defense procurement and supply chains." },
      { name: "Energy & Utilities", desc: "Competition policy in energy markets, utility mergers, and infrastructure." },
      { name: "Telecommunications & Media", desc: "Antitrust considerations in telecom consolidation and media mergers." },
      { name: "Transportation & Logistics", desc: "Competition matters in shipping, aviation, rail, and logistics." },
    ],
  },
  {
    category: "Industrial & Consumer Markets",
    industries: [
      { name: "Manufacturing & Industrial Markets", desc: "Antitrust issues in industrial consolidation, supply agreements, and B2B markets." },
      { name: "Consumer Products & Retail", desc: "Distribution practices, resale pricing, and retail competition matters." },
      { name: "Real Estate & Infrastructure", desc: "Competition issues in real estate markets and infrastructure development." },
      { name: "Financial Services & Fintech", desc: "Merger review and competition policy in banking, insurance, and fintech." },
    ],
  },
];

const Industries = () => (
  <Layout>
    <PageHead title="Industry Antitrust Expertise" description="Alicia Batts provides antitrust counsel across technology, healthcare, life sciences, private equity, aerospace, energy, and financial services industries." path="/industries" keywords="Alicia Batts industry antitrust, technology antitrust, healthcare competition law, private equity antitrust, financial services antitrust, Batts Legal industries" />
    <section className="bg-hero text-primary-foreground py-20">
      <div className="editorial-container">
        <AnimatedSection animation="fade" delay={0}><div className="gold-accent-line mb-6" /></AnimatedSection>
        <AnimatedSection animation="fade-up" delay={100}>
          <h1 className="text-4xl md:text-5xl font-serif font-semibold mb-4">Industries</h1>
        </AnimatedSection>
        <AnimatedSection animation="fade-up" delay={200}>
          <p className="text-lg opacity-80 max-w-2xl">Deep understanding of competitive dynamics across the industries that matter most to antitrust enforcement.</p>
        </AnimatedSection>
      </div>
    </section>
    <section className="section-padding">
      <div className="editorial-container space-y-16">
        {industryGroups.map((group, gi) => (
          <div key={group.category}>
            <AnimatedSection animation="fade-left">
              <p className="text-xs font-semibold uppercase tracking-widest text-gold mb-6">{group.category}</p>
            </AnimatedSection>
            <div className="grid md:grid-cols-2 gap-6">
              {group.industries.map((ind, i) => (
                <AnimatedSection key={ind.name} animation="fade-up" delay={i * 100}>
                  <div className="bg-card rounded-md p-8 shadow-card border border-border h-full">
                    <h3 className="font-serif text-lg font-semibold text-foreground mb-2">{ind.name}</h3>
                    <p className="text-muted-foreground text-sm leading-relaxed">{ind.desc}</p>
                  </div>
                </AnimatedSection>
              ))}
            </div>
          </div>
        ))}
      </div>
    </section>
  </Layout>
);

export default Industries;
